import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// ── Adaptive image loading based on connection quality ──────────────────
(function () {
  try {
    const conn = (navigator as Navigator & { connection?: { effectiveType?: string; saveData?: boolean } }).connection;
    const effectiveType = conn?.effectiveType ?? '4g';
    const saveData = conn?.saveData ?? false;
    const isSlow = saveData || effectiveType === 'slow-2g' || effectiveType === '2g' || effectiveType === '3g';

    if (isSlow) {
      // On slow connections, override the hero preload to use the 400w version
      const heroPreload = document.querySelector<HTMLLinkElement>('link[rel="preload"][as="image"][fetchpriority="high"], link[rel="preload"][as="image"][imagesrcset]');
      if (heroPreload) {
        const lowResUrl = 'https://assets.cdn.filesafe.space/rc8Fx2cZBlMBT1xVdV7Z/media/6a0e37a1e05851175c1e211e.webp?width=400';
        heroPreload.setAttribute('href', lowResUrl);
        heroPreload.removeAttribute('imagesrcset');
        heroPreload.removeAttribute('imagesizes');
      }
      // Tag the document so the Hero component can read it
      document.documentElement.setAttribute('data-slow-connection', '1');
    }
  } catch {
    // navigator.connection not supported — no-op
  }
})();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

const rootEl = document.getElementById("root")!;

createRoot(rootEl).render(<App />);

// Define global shell removal function to be called by React components
(window as any).removeHeroShell = () => {
  const shell = document.getElementById('hero-shell');
  if (shell && shell.style.opacity !== '0') {
    // Using requestAnimationFrame to ensure the paint has happened
    requestAnimationFrame(() => {
      shell.style.transition = 'opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
      shell.style.opacity = '0';
      shell.style.pointerEvents = 'none';
      setTimeout(() => {
        if (shell.parentNode) shell.remove();
        document.body.style.overflow = '';
      }, 650);
    });
  }
};



